import { axiosClient } from "../api/axiosClient";

export interface PushSubscriptionPayload {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
  userAgent?: string;
}

export const pushSubscriptionRepository = {
  async getVapidPublicKey(): Promise<string | null> {
    const { data } = await axiosClient.get<{ publicKey: string | null }>(
      "/push-subscriptions/vapid-public-key",
    );
    return data.publicKey;
  },

  async subscribe(payload: PushSubscriptionPayload) {
    const { data } = await axiosClient.post("/push-subscriptions", payload);
    return data;
  },

  async unsubscribe(endpoint: string) {
    const { data } = await axiosClient.delete("/push-subscriptions", {
      data: { endpoint },
    });
    return data;
  },
};
